export default __webpack_public_path__ + "static/media/ic_expand.58a2a26f.svg";